import { Stack, Typography, useTheme } from '@mui/material';
import { PlayCircle, StopCircle } from '@phosphor-icons/react';
import dayjs from 'dayjs';

import DashedLineIcon from '@/assets/icons/dashed-lines.svg?react';
import { ResultStructureSummary } from '@/components/result/ResultStructureSummary';
import type { RouteResultStructure } from '@/modules/api-routing';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';

interface ResultStructureDetailsProps {
  resultStructure: RouteResultStructure;
}

export function ResultStructureDetails({ resultStructure }: ResultStructureDetailsProps) {
  const theme = useTheme();

  const origin = useRoutesStore((state) => state.routeLocations[RouteLocationType.ORIGIN]);
  const destination = useRoutesStore((state) => state.routeLocations[RouteLocationType.DESTINATION]);

  const algorithm =
    resultStructure?.route?.extension?.any.value.modeMetaInfo[0].tripModeAlgorithm.individualAlgorithm[0];

  const arrival = dayjs(resultStructure?.route?.startTime)
    .add(dayjs.duration(resultStructure?.route?.duration ?? {}))
    .toISOString();

  return (
    <Stack gap={4} mt={2} width={362}>
      <Stack gap={3}>
        <ResultStructureSummary
          isDetail
          algorithm={algorithm}
          arrival={arrival}
          distance={resultStructure?.route?.distance}
          duration={resultStructure?.route?.duration}
        />
      </Stack>

      <Stack alignItems="flex-start" gap={1}>
        <Stack alignItems="center" direction="row" gap={1.5}>
          <PlayCircle size={24} style={{ color: theme.palette.primary.main }} weight="fill" />
          <Typography color="textSecondary" variant="body2">
            {origin?.properties.name.full}
          </Typography>
        </Stack>

        <Stack sx={{ position: 'relative', height: 0, pl: '12px' }}>
          <div
            style={{
              position: 'absolute',
              top: -10.5,
              left: 10.5,
            }}
          >
            <DashedLineIcon />
          </div>
        </Stack>

        <Stack alignItems="center" direction="row" gap={1.5}>
          <StopCircle size={24} style={{ color: theme.palette.primary.dark }} weight="fill" />
          <Typography color="textSecondary" variant="body2">
            {destination?.properties.name.full}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
